export async function loadDataSettingsGuideUseCase(showSettingsGuidelData, settingsGuideRepository) {
    const result = await settingsGuideRepository.get_settings_guide(showSettingsGuidelData);
    const entity = new settingsGuideRepository.model(result)
    
    if (!entity.isValid()) {
      throw new Error("settings guide inválido");
    }

    return entity;
}